import Autocomplete from '@zenbusiness/zui/Autocomplete';
import { styled } from '@zenbusiness/zui/styles';

export const AutocompleteStyle = () => ({
  '& .MuiInputBase-root': {
    paddingTop: '24px',
    paddingLeft: '16px',
    paddingBottom: '5px',
    '& .MuiInputBase-input': {
      padding: '0 0 0 0 !important',
      borderRadius: '0'
    }
  }
});

export const AutocompleteStyled = styled(Autocomplete)(AutocompleteStyle);
